import React, {useContext, useEffect} from 'react'
import {Redirect, Route} from 'react-router-dom'
import {AuthContext} from "../context/AuthContext";
import {FiltersContext} from "../context/FiltersContext";

const PrivateRoute = ({component: Component, ...rest}) => {

    const authContext = useContext(AuthContext);
    const isLoggedIn = authContext.isLogged();

    const {
        routesToKeepKpi,
        initFiltroKpi
    } = useContext(FiltersContext);

    var hash = document.location.hash || ''
    if (hash) {
        hash = hash.replaceAll('#', '')
    }

    useEffect(() => {
        let kpiOk = false;

        routesToKeepKpi.forEach(route => {
            if (hash.indexOf(route) !== - 1) {
                kpiOk = true;
            }
        });
        if (kpiOk === false) {
            initFiltroKpi();
        }
    }, [hash]);

    return (
        <Route
            {...rest}
            render={props =>
                isLoggedIn ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={{
                        pathname: '/login', state: {
                            from: props.location,
                            hash: hash
                        }
                    }}/>
                )
            }
        />
    )
}

export default PrivateRoute